'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.realtime = undefined;

var _pubSubClientGetters = require('conversations-internal-pub-sub/redux/selectors/pubSubClientGetters');

var _statusComparators = require('conversations-async-data/async-data/operators/statusComparators');

var _actionTypes = require('../../threads/constants/actionTypes');

var _hasPersistedThreads = require('../../threads/selectors/hasPersistedThreads');

var _VisitorActionTypes = require('../../constants/VisitorActionTypes');

var ActionTypes = _interopRequireWildcard(_VisitorActionTypes);

var _startPubSub = require('../actions/startPubSub');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var realtime = exports.realtime = function realtime(store) {
  return function (next) {
    return function (action) {
      var result = next(action);

      var asyncPubSubClient = (0, _pubSubClientGetters.getAsyncPubSubClient)(store.getState());

      if ((0, _statusComparators.isUninitialized)(asyncPubSubClient) && action.type === _actionTypes.CREATE_NEW_THREAD.SUCCEEDED) {
        var _action$payload = action.payload,
            channel = _action$payload.channel,
            threadId = _action$payload.threadId;

        store.dispatch((0, _startPubSub.startPubSub)({
          // TODO [Follow up]: Remove this when messages can be posted to the thread create endpoint
          publishStagedMessages: true,
          channel: channel,
          threadId: threadId
        }));
      }

      if ((0, _statusComparators.isUninitialized)(asyncPubSubClient) && action.type === ActionTypes.GET_VISITOR_THREADS_SUCCESS && (0, _hasPersistedThreads.hasPersistedThreads)(store.getState())) {
        store.dispatch((0, _startPubSub.startPubSub)({ publishStagedMessages: false }));
      }

      return result;
    };
  };
};